const dataexplorerSignupButton = [
  '$uibModal',
  function ($uibModal) {
    return {
      restrict: 'AE',
      scope: {},
      link: function (scope, element, attrs) {
        element.on('click', () => {
          if (isMobile.check({ phoneOnly: true })) {
            document.location = '/data-explorer/signup'
          } else {
            scope.modalInstance = $uibModal.open({
              component: 'dataexplorerSignupForm',
              windowClass: 'v3-modal-simple full-width',
            })
          }
        })
      },
    }
  },
]
export default dataexplorerSignupButton
